import IPublic from "@/interface/public";
import { ConfDoData, JoinAndFinishData, Mydj } from '@/interface/request.interface'
import { Modal } from "@/views/component/modal";
import { EModal } from "@/interface/enum";

async function $ajax<T>(
  url: string,
  option: IPublic.KeyVal = { data: {}, dataType: 'jsonp' },
  intact: boolean = false
): Promise<T> {
  return new Promise(async (resolve, reject) => {
    const res = await f2eGame.util.loadData({
      url,
      ...option
    });
    if (res.code === 0 || res.status === 200 || res.result === 0) {
      return resolve(intact ? res : res.data);
    }
    reject(new Error(JSON.stringify(res)));
  });
}

type ITaskType = 'conf' | 'mydj' | 'joinAndFinish' | 'myPackage';

async function postTask3<T>(type: ITaskType, postData: IPublic.KeyVal): Promise<T> {
  return new Promise(async (resolve, reject) => {
    const res = await f2eGame.port.task3[type](postData);
    if (res.code === 0 || res.status === 200) {
      return resolve(res.data);
    }
    return reject(res);
  })
}

function conf(actCode: string) {
  return (): Promise<ConfDoData> => {
    return new Promise((resolve, reject) => {
      return postTask3<ConfDoData>('conf', { actCode })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          $refPopup.current.open((props: any) => Modal({
            ...props,
            modalType: EModal['提示'],
            message: res.message
          }));
          reject(new Error(JSON.stringify(res)));
        });
    })
  }
}

function mydj(actCode: string) {
  return (): Promise<Mydj> => {
    return new Promise((resolve, reject) => {
      return postTask3<Mydj>('mydj', { prizeId: actCode })
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(new Error(JSON.stringify(res)));
        });
    })
  }
}


function joinAndFinish(postData: IPublic.KeyVal): Promise<JoinAndFinishData> {
  return new Promise((resolve, reject) => {
    postTask3<JoinAndFinishData>('joinAndFinish', postData)
      .then((res) => {
        resolve(res);
      })
      .catch((res) => {
        reject(new Error(JSON.stringify(res)));
      });
  })
}

export {
  postTask3,
  conf,
  joinAndFinish,
  mydj,
  $ajax
}
